import { gql, MutationFunction } from '@apollo/client';

export const UpdateOrganization = gql`
  mutation UpdateOrganization(
    $code: String!
    $accountId: String!
    $domains: [String!]!
  ) {
    updateOrganization(code: $code, accountId: $accountId, domains: $domains)
  }
`;

export type UpdateOrganizationMutation = MutationFunction<
  UpdateOrganizationData,
  UpdateOrganizationVariables
>;
